
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const MAX_DEPTH = 10;
const getDataComponent = _ref => {
  var _node$attributes;
  let {
    node
  } = _ref;
  const dataComponent = node === null || node === void 0 ? void 0 : (_node$attributes = node.attributes) === null || _node$attributes === void 0 ? void 0 : _node$attributes['data-component'];
  if (!dataComponent) return null;
  return {
    dataComponent: dataComponent.value
  };
};
const parentTraversalForDataComponent = _ref2 => {
  let {
    node = {},
    depth = 0
  } = _ref2;
  if (depth >= MAX_DEPTH || !node) return null;
  const dataComponent = getDataComponent({
    node
  });
  if (dataComponent) return _objectSpread(_objectSpread({}, dataComponent), {}, {
    depth
  });
  return parentTraversalForDataComponent({
    node: node.parentElement,
    depth: depth + 1
  });
};
const bfsTraversalForDataComponent = _ref3 => {
  let {
    queue = []
  } = _ref3;
  while (queue.length) {
    const {
      node,
      depth
    } = queue.shift() || {};
    const dataComponent = getDataComponent({
      node
    });
    if (dataComponent) return _objectSpread(_objectSpread({}, dataComponent), {}, {
      depth
    });
    if (depth > MAX_DEPTH || !node) break;
    if (node !== null && node !== void 0 && node.hasChildNodes()) {
      // eslint-disable-next-line no-restricted-syntax
      for (const childNode of node.childNodes) {
        queue.push({
          node: childNode,
          depth: depth + 1
        });
      }
    }
  }
  return null;
};
export const findDataComponent = _ref4 => {
  let {
    node
  } = _ref4;
  const firstNode = {
    node,
    depth: 0
  };
  const parent = parentTraversalForDataComponent(firstNode);
  const child = bfsTraversalForDataComponent({
    queue: [firstNode]
  });
  if (!parent && !child) return null;
  if (parent && child) {
    if (parent.depth <= child.depth) return parent.dataComponent;
    return child.dataComponent;
  }
  return _objectSpread(_objectSpread({}, parent), child).dataComponent;
};
//# sourceMappingURL=performance-observer-helpers.js.map